import {
  CONFIGURATION_RECORD_ACTIVE,
  CONFIGURATION_RECORD_INACTIVE,
} from '../constants/configuration';

export function activeConfigurationFilters<T extends object>(
  filters?: T,
): T & { isActive: boolean } {
  return {
    ...(filters ?? ({} as T)),
    isActive: CONFIGURATION_RECORD_ACTIVE,
  };
}

export function isActiveConfigurationRecord(
  isActive: boolean | null | undefined,
): boolean {
  return isActive !== CONFIGURATION_RECORD_INACTIVE && isActive !== false;
}
